import {Direction} from "@/models/enum/Direction";

export enum DisputeReason {
    HAS_PAYMENT = 'has_payment',
    NO_PAYMENT = 'no_payment',
    INVALID_SUM = 'invalid_sum',
    INVALID_REQUISITES = 'invalid_requisites',
    UNABLE_TO_PAY_OUT_ON_REQ = 'unable_to_payout_to_req',
    PART_PAYOUT = 'part_payout',
    PAYOUT_BLACKLIST = 'payout_blacklist',
    WAITING_CONFIRMATION = 'waiting_confirmation',
    RECEIPT_CHECKING = 'receipt_checking',
    RECEIPT_CHECK_PASSED = 'receipt_check_passed',
    RECEIPT_CHECK_FAILED = 'receipt_check_failed',
}

export const isReceiptCheckReason = (reason: DisputeReason|string|null|undefined): boolean => {
    return reason === DisputeReason.RECEIPT_CHECKING
        || reason === DisputeReason.RECEIPT_CHECK_PASSED
        || reason === DisputeReason.RECEIPT_CHECK_FAILED;
}

export const isPayOutReceiptCheck = (type: Direction|string|null|undefined, reason: DisputeReason|string|null|undefined): boolean => {
    return type === Direction.PAY_OUT && isReceiptCheckReason(reason);
}